import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'

import Layout from '@/layout'

// import store from '@/store'
// import { getToken, removeToken } from '@/utils/cookie'
// import { apiGetUser } from '@/apis/user'

NProgress.configure({ showSpinner: false })

Vue.use(VueRouter)

const routes = [
  {
    path: '/party',
    component: Layout,
    redirect: '/party/index',
    children: [
      {
        path: 'index',
        name: 'Home',
        component: () => import('@/views/home/index.vue')
      },
      {
        path: 'details',
        name: 'HomeDetails',
        component: () => import('@/views/home/Details.vue')
      },
      {
        path: 'search',
        name: 'SearchNews',
        component: () => import('@/views/home/SearchNews.vue')
      }
    ]
  },
  {
    path: '/party/contact',
    component: Layout,
    redirect: '/party/contact/index',
    children: [
      {
        path: 'index',
        name: 'ContatcUs',
        component: () => import('@/views/contact-us/index.vue')
      }
    ]
  },
  {
    path: '/party/focus',
    component: Layout,
    redirect: '/party/focus/index',
    children: [
      {
        path: 'index',
        name: 'FocusNews',
        component: () => import('@/views/focus-news/index.vue')
      }
    ]
  },
  {
    path: '/party/members',
    component: Layout,
    redirect: '/party/members/index',
    children: [
      {
        path: 'index',
        name: 'GroupMembers',
        component: () => import('@/views/group-members/index.vue')
      }
    ]
  },
  {
    path: '/party/notice',
    component: Layout,
    redirect: '/party/notice/index',
    children: [
      {
        path: 'index',
        name: 'Notice',
        component: () => import('@/views/notice/index.vue')
      }
    ]
  },
  {
    path: '/party/build',
    component: Layout,
    redirect: '/party/build/index',
    children: [
      {
        path: 'index',
        name: 'OrganizeBuild',
        component: () => import('@/views/organize-build/index.vue')
      }
    ]
  },
  {
    path: '/party/guide',
    component: Layout,
    redirect: '/party/guide/index',
    children: [
      {
        path: 'index',
        name: 'PartyGuide',
        component: () => import('@/views/party-guide/index.vue')
      },
      {
        path: 'question',
        name: 'PartyGuideQuestion',
        component: () => import('@/views/party-guide/Question.vue')
      },
      {
        path: 'doGuide',
        name: 'PartyGuideDo',
        component: () => import('@/views/party-guide/DoGuide.vue')
      }
    ]
  },
  {
    path: '/party/rules',
    component: Layout,
    redirect: '/party/rules/index',
    children: [
      {
        path: 'index',
        name: 'PartyRules',
        component: () => import('@/views/party-rules/index.vue')
      }
    ]
  },
  {
    path: '/party/spirit',
    component: Layout,
    redirect: '/party/spirit/index',
    children: [
      {
        path: 'index',
        name: 'PartySpirit',
        component: () => import('@/views/party-spirit/index.vue')
      }
    ]
  },
  {
    path: '/party/work',
    component: Layout,
    redirect: '/party/work/index',
    children: [
      {
        path: 'index',
        name: 'WorkTrends',
        component: () => import('@/views/work-trends/index.vue')
      }
    ]
  },
  {
    path: '/party/presence',
    component: Layout,
    redirect: '/party/presence/index',
    children: [
      {
        path: 'index',
        name: 'PartyPresence',
        component: () => import('@/views/party-presence/index.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: '/party/index'
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
  routes
})

router.beforeEach((to, from, next) => {
  NProgress.start()

  // // 获取用户信息
  // if (getToken('token')) {
  //   apiGetUser()
  //     .then((res) => {
  //       store.commit('user/SET_USER_INFO', res.data)
  //     })
  //     .catch((err) => {
  //       console.error(err.message || '未知错误')
  //       removeToken('c')
  //     })
  // }

  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
